<template>
  <div @mouseleave="hideMegaMenu()" class="megamenu-wrapper">
    <div class="grid-container grid-container--fit">
      <div class="grid-element"
           v-for="(category, k) in categories" :key="k"
           @mouseover="changeMainCategory(k)"
           :class="['main-category', isActive(k) ? 'active' : '']"
      >
        <div class="label mb-2">
          <inertia-link :href="route('shop.category.view', category.slug)">
            <span v-if="category.name == 'Sales'" style="color:red" class="my-0 text-sm">{{ category.name }}</span>
            <span v-else class="my-0 text-sm">{{ category.name }}</span>
          </inertia-link>
        </div>
        <span v-if="category.mapped">
          <ul class="text-hoverable list-unstyled py-0 my-0">
            <li v-for="mapped in category.mapped" :key="mapped.slug">
              <inertia-link :href="route('shop.category.view', [category.slug, mapped.slug])">
                <span><i>{{ mapped.name }}</i></span>
              </inertia-link>
            </li>
          </ul>
        </span>
        <span v-else>
              <inertia-link :href="route('shop.category.view', [category.slug])">
                <span><i>{{ category.name }}</i></span>
              </inertia-link>
        </span>


      </div>
    </div>
    <!--    <div class="sub-categories">-->
    <!--&lt;!&ndash;      <img :src="categories[activeMainCategory].image"  class="img img-fluid pb-2"/>&ndash;&gt;-->
    <!--      <div v-for="mapped in categories[activeMainCategory].mapped" :key="mapped.slug" class="sub-category">-->
    <!--        <div class="label">-->
    <!--          {{ mapped.name }}-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import eventBus from "../eventBus";

export default {
  name: "MegaMenu",
  data() {
    return {
      activeMainCategory: 1,
      lastX: 0,
      lastY: 0,
      direction: "",
      throttle: false,
    };
  },
  props: {
    categories: Object,
  },
  methods: {
    hideMegaMenu() {
      eventBus.$emit("hide-mega-menu");
    },
    isActive(key) {
      return this.activeMainCategory === key;
    },
    mouseDirection(e) {
      if (!this.throttle) {
        this.throttle = true;
        let theta = Math.abs(
            (180 * Math.atan2(e.pageY - this.lastY, e.pageX - this.lastX)) /
            Math.PI
        );
        this.direction = theta > 75 ? "vertical" : "horizontal";
        this.lastX = e.pageX;
        this.lastY = e.pageY;
        setTimeout(() => {
          this.throttle = false;
        }, 50);
      }
    },
    changeMainCategory(index) {

      if (this.direction === "vertical") {
        this.activeMainCategory = index;
      }
    },
  },
  mounted() {
    window.addEventListener("mousemove", this.mouseDirection);
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.mouseDirection);
  },
};
</script>

<style>
.grid-container {
  display: grid;
}

.grid-container--fit {
  grid-template-columns: repeat(auto-fit, minmax(95px, 1fr));
}

.grid-element {
  color: rgb(60, 60, 60);
  font-size: 0.7rem !important;
  padding: 5px;
  /*border-block-end: 1px solid #a4a4a4;*/
}

.megamenu-wrapper {
  z-index: 9999;
  position: absolute;
  /*border: 1px solid #a4a4a4;*/
  border-top: none;
  width: 95vw;
  background: rgba(255, 255, 255, 0.9);
  /*display: grid;*/
  /*grid-template-columns: 1fr 3fr;*/
  /*grid-template-rows: 1fr;*/
  /*gap: 0px 0px;*/
  /*grid-template-areas: ". .";*/
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  top: 98px;
}

.main-categories {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  gap: 0px 0px;
  border-right: 1px solid #a4a4a4;
}

.main-category {
  /*display: flex;*/
  /*cursor: pointer;*/
  /*flex-direction: row;*/
  /*align-items: center;*/
  /*padding-left: 30px;*/
}

/*.main-category:first-of-type {*/
/*  border-left: 1px solid #a4a4a4;*/
/*}*/
/*.main-category:last-of-type {*/
/*  border-right: 1px solid #a4a4a4;*/
/*}*/
/*.main-category:not(:last-of-type) {*/
/*  border-right: 1px solid #fff;*/
/*}*/

.main-category .icon {
  margin-right: 15px;
}

.main-category.active {
  background: #efefef;
}

.sub-categories {
  background: rgba(255, 255, 255, 0.7);
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  gap: 0px 0px;
  border-right: 1px solid #a4a4a4;
}

.sub-category {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.sub-category:hover {
  background: #dedede;
}

.grid-element .label {
  text-decoration: underline;
  font-weight: bold;
}
</style>
